var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsFilledPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#684199",
    fillRule: "evenodd",
    d: "M7.5 2A2.5 2.5 0 0 0 5 4.5v23A2.5 2.5 0 0 0 7.5 30h17a2.5 2.5 0 0 0 2.5-2.5V17a5 5 0 0 0-5-5h-2.5A2.5 2.5 0 0 1 17 9.5V7a5 5 0 0 0-5-5zM10 20a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H11a1 1 0 0 1-1-1m1 3a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bab4c3",
    d: "M17.295 2.421A6.97 6.97 0 0 1 19 7v2.5a.5.5 0 0 0 .5.5H22a6.97 6.97 0 0 1 4.579 1.705 13.02 13.02 0 0 0-9.284-9.284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsFilledPurple);
export default __webpack_public_path__ + "static/media/documents_filled_purple.9b88d8771b792fd5c1450c91da72f2f2.svg";
export { ForwardRef as ReactComponent };